<script lang="ts" setup>
import type { HTMLAttributes } from "vue";
import { reactiveOmit } from "@vueuse/core";
import {
    RangeCalendarCell,
    type RangeCalendarCellProps,
    useForwardProps,
} from "reka-ui";
import { cn } from "@/lib/utils";

const props = defineProps<
    RangeCalendarCellProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = reactiveOmit(props, "class");

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <RangeCalendarCell
        :class="
            cn(
                'relative p-2 text-center focus-within:relative focus-within:z-20',
                '[&:has([data-selected])]:before:absolute [&:has([data-selected])]:before:inset-0 [&:has([data-selected])]:before:bottom-1 [&:has([data-selected])]:before:top-1 [&:has([data-selected])]:before:z-[0] [&:has([data-selected])]:before:content-[\'\']',
                '[&:has([data-selected]:not([data-highlighted]))]:before:bg-[#FFCFB0]',
                'first:[&:has([data-selected])]:before:rounded-l-full last:[&:has([data-selected])]:before:rounded-r-full',
                '[&:has([data-selected][data-outside-view])]:before:bg-[#FFCFB0]/50',
                '[&:has([data-selected][data-selection-end])]:before:right-1 [&:has([data-selected][data-selection-end])]:before:rounded-r-full [&:has([data-selected][data-selection-start])]:before:left-1 [&:has([data-selected][data-selection-start])]:before:rounded-l-full',
                '[&:has([data-selected][data-selection-start]):last-child]:before:right-1',
                '[&:has([data-selected][data-selection-end]):first-child]:before:left-1',
                props.class,
            )
        "
        v-bind="forwardedProps"
    >
        <slot />
    </RangeCalendarCell>
</template>
